import base from "../../libs/axios";

export const getSubscriptions = () =>
  base.get(`/api/subscriptions/all`).then(({ data }) => data);
